import { ReactNode } from "react";
import { spacing } from "../../stitches.config";
import { FlexColumn, FlexRow } from "./__styles__/Layout";
import { Box } from "./__styles__/Settings";
import Banner from "./Banner";
import { Body, Title } from "./Typography";

export const SettingsPanel = ({
  title,
  children,
  showInsufficientPermissionsBanner = false,
  actionButton,
}: {
  title: string;
  children: ReactNode;
  showInsufficientPermissionsBanner?: boolean;
  actionButton?: ReactNode;
}) => (
  <FlexColumn gap="l" style={{ marginBottom: `${spacing.l}` }}>
    {showInsufficientPermissionsBanner && <InsufficientPermissionsBanner />}
    <Box>
      <FlexRow style={{ justifyContent: "space-between" }}>
        <Title size="small" type="semiBold">
          {title}
        </Title>
        {actionButton && actionButton}
      </FlexRow>
      {children}
    </Box>
  </FlexColumn>
);

export const SettingsSection = ({
  title,
  subtitle,
  children,
  actionButton,
  fullWidth = false,
}: {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  actionButton?: ReactNode;
  fullWidth?: boolean;
}) => {
  return (
    <FlexColumn gap="m" style={{ ...(fullWidth && { width: "100%" }) }}>
      <FlexRow
        style={{
          justifyContent: "space-between",
          ...(fullWidth && { width: "100%" }),
        }}
      >
        <FlexColumn gap="xs">
          <Body size="large" type="emphasis">
            {title}
          </Body>
          {subtitle && (
            <Body size="default" type="regular" color="contentSecondary">
              {subtitle}
            </Body>
          )}
        </FlexColumn>
        {actionButton && actionButton}
      </FlexRow>
      {children}
    </FlexColumn>
  );
};

export const InsufficientPermissionsBanner = () => {
  return (
    <div style={{ margin: `${spacing.m} 0` }}>
      <Banner>
        You do not have permission to edit these account settings. Please reach
        out to your Team manager to make changes.
      </Banner>
    </div>
  );
};
